// @ts-nocheck
import { useEffect, useState } from "react";
import Select from "react-select";
import { useUiStore } from "src/components/main/uiStore";
//---------------------------------------------------------------------
import Modal from "src/components/common/Modal";
import {
    myAxios,
    /* MyDate */
} from "src/components/common/functions";
import { useNavigate, useParams } from "react-router-dom";
//---------------------------------------------------------------------
export default function Yard({
    closeIt, 
    tabTitle
}){
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const navigate = useNavigate();
    const { settingId, action } = useParams();
    const [settingsData, setSettingsData] = useState({});
    const settingsDataArr = Object.entries(settingsData);
    const [yardsData, setYardsData] = useState({});
    const [yard, setYard] = useState("");
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res1 = await myAxios({ fileName: "fleet/readInventory.php" });
            if(!isMounted) return;
            setShowLoader(false);
            if(!res1) return;
            //---------------------------------------------------------------------
            setSettingsData(res1.data);
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res2 = await myAxios({ fileName: "fleet/readInventoryYards.php" });
            if(!isMounted) return;
            setShowLoader(false);
            if(!res2) return;
            //---------------------------------------------------------------------
            setYardsData(res2.data);
        }
        getData();
        return () => isMounted = false;
    }, [setShowLoader]);
    return (
        <Modal
            closeIt = {closeIt}
            title = {"Yard"}
            width = {"60%"}
            actionKey = "Save"
            handleFormSubmit = {async() => {
                // yardsData[yard].inventoryUpdateTime = new MyDate().s() + " " + new MyDate().ss();
                const formData = new FormData();
                formData.append("data", JSON.stringify(yardsData));
                //---------------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios({ fileName: "fleet/updateYardInventory.php", formData: formData });
                setShowLoader(false);
                if(!res) return;
                //---------------------------------------------------------------------
                closeIt();
            }}
        >
            <div className = "d-flex align-items-center my-2">
                <label htmlFor = {"yardSelect"}>Yard</label>
                <select
                    required
                    id = {"yardSelect"}
                    value = {yard}
                    onChange = {e => {
                        if(yard !== "" && Object.values(yardsData[yard].inventory).some(item => item.qty === "")){
                            alert("Quantity is missing.");
                            return;
                        }
                        setYard(e.currentTarget.value);
                    }}
                    className = "ms-2 form-control"
                >
                    <option value = {""}>Select</option>
                    {Object.entries(yardsData).map(entry => <option key = {entry[0]} value = {entry[0]}>{entry[1].title}</option>)}
                </select>
                <span className = "ms-2 text-info">{yardsData[yard]?.yardNote}</span>
            </div>
            {yard?<>
            <div className = "d-flex align-items-center my-2">
                <label htmlFor = "new item">Items</label>
                <Select
                    isMulti
                    inputId = "new item"
                    className = "ms-2 flex-grow-1"
                    options = {settingsDataArr.map(([key, {title, path, note }]) => ({
                        path, title, note,
                        label: title,
                        value: key
                    }))}
                    value = {Object.entries(yardsData[yard].inventory).map(([key, {qty, yardItemNote}]) => ({
                        qty, yardItemNote,
                        label: settingsData[key]?.title ?? "",
                        value: key
                    }))}
                    onChange = {e => {
                        const originArr = Object.entries(yardsData[yard].inventory);
                        const arr = e?.map(({ value }) => 
                            originArr.some(entry => 
                                entry[0] === value
                            )?
                            originArr.find(entry => 
                                entry[0] === value
                            )
                            :
                            [value, {
                                qty: "",
                                yardItemNote: ""
                            }]
                        );
                        setYardsData(
                            {
                                ...yardsData,
                                [yard]: {
                                    ...yardsData[yard],
                                    inventory: Object.fromEntries(arr)
                                }
                            }
                        );
                    }}
                />
            </div>
            {Object.entries(yardsData[yard].inventory).map(([key, renderedValue], index) => 
            <li className = "my-3 d-flex align-items-center" key = {index}>
                <label
                    htmlFor = {key + " item"}
                >
                    Item {index + 1}
                </label>
                {settingsData[key]?.path?
                <img
                    className = "ms-2 rounded"
                    src = {settingsData[key].path}
                    alt = ""
                    style = {{
                        width: 100, 
                        height: 100
                    }}
                />:
                <></>
                }
                <input
                    data-toggle = "tooltip"
                    title = {settingsData[key]?.note ?? ""}
                    id = {key + " item"}
                    className = {`ms-2 form-control flex-grow-1 ${settingsData[key]?.note?"text-info":""}`}
                    readOnly
                    value = {settingsData[key]?.title ?? ""}
                />
                    <label
                        className = "ms-2"
                        htmlFor = {key + " qty"}
                    >
                        Quantity
                    </label>
                <input
                    required
                    type = "number"
                    min = {0} id = {key + " qty"}
                    className = "form-control ms-2"
                    style = {{width: "100px"}}
                    value = {renderedValue.qty}
                    onChange = {e => {
                        const targetValue = e.currentTarget.value;
                        setYardsData(
                            {
                                ...yardsData,
                                [yard]: {
                                    ...yardsData[yard],
                                    inventory: 
                                    {
                                        ...yardsData[yard].inventory, 
                                        [key]: {
                                            ...yardsData[yard].inventory[key],
                                            qty: targetValue
                                        }
                                    }
                                }
                            }
                        );
                    }}
                />
                <label className = "ms-2" htmlFor = {key + " yardItemNote"}>Note</label>
                <input
                    id = {key + " yardItemNote"}
                    className = {"ms-2 form-control flex-grow-1"}
                    value = {renderedValue.yardItemNote}
                    onChange = {e => {
                        const value = e.currentTarget.value;
                        setYardsData(
                            {
                                ...yardsData,
                                [yard]: {
                                    ...yardsData[yard],
                                    inventory: 
                                    {
                                        ...yardsData[yard].inventory, 
                                        [key]: {
                                            ...yardsData[yard].inventory[key],
                                            yardItemNote: value
                                        }
                                    }
                                }
                            }
                        );
                    }}
                />
                <span>
                </span>
                <span>
                    <button type = "button" className = "btn btn-info ms-2" onClick = {() => {
                        navigate(`/${tabTitle}/Yard/${key}/order`);
                    }}>
                        ⇅
                    </button>
                    {action === "order"?
                    <Order
                        id = {settingId}
                        closeIt = {() => navigate(`/${tabTitle}/Yard`)}
                        setYardsData = {setYardsData}
                        yardsData = {yardsData}
                        settingsData = {settingsData}
                        yard = {yard}
                    />:<></>}
                </span>
            </li>)
            }
            </>:<></>}
        </Modal>
    )
}

function Order({ id, yardsData, yard, setYardsData, settingsData, closeIt }){
    const arr = Object.entries(yardsData[yard].inventory).map((entry, index) =>([...entry, index]));
    const originIndex = arr.find(entry => entry[0] === id)[2];
    const [target, setTarget] = useState("");
    return(
        <Modal
            touchOutsideClose
            closeIt = {closeIt}
            title = {"Change Order of " + settingsData[id].title}
            width = {"60%"}
            onSave = {() => {
                const result = [];
                if(!target){
                    result.push([id, yardsData[yard].inventory[id]], ...arr.filter(entry => entry[0] !== id));
                }else{
                    let targetIndex = -1;
                    for(let i = 0; i < arr.length; i++){
                        if(arr[i][0] === target){
                            targetIndex = i;
                        }
                    }
                    result.push(
                        ...arr.slice(0, targetIndex + 1).filter(entry => entry[0] !== id), 
                        [id, yardsData[yard].inventory[id]],
                        ...arr.slice(targetIndex + 1).filter(entry => entry[0] !== id)
                    )
                }
                setYardsData({
                    ...yardsData,
                    [yard]: {
                        ...yardsData[yard],
                        inventory: Object.fromEntries(result)
                    }
                }); //*
                closeIt();
            }}
        >
            <div>
                <select
                    className = "form-control m-3"
                    value = {target}
                    onChange = {e => setTarget(e.currentTarget.value)}
                >
                    <option value = {""} disabled = {originIndex === 0}>
                        At the Top
                    </option>
                    {arr.map(([key, value], renderedIndex) => 
                    <option
                        disabled = {renderedIndex === originIndex || renderedIndex + 1 === originIndex}
                        key = {key}
                        value = {key}
                    >
                        After {settingsData[key].title}
                    </option>
                    )}
                </select>
            </div>
        </Modal>
    );
}